<app-filter-panel [fields]="fieldsConfig" (search)="search()"></app-filter-panel>

<!--
<div class="flex gap-2 flex-wrap">
    <div class="input-field" style="min-width:200px">
        <label for="userId">Usuario</label>
        <p-multiSelect [options]="users" optionLabel="name" optionValue="id" [(ngModel)]="filters.userId.value"
            (onPanelHide)="search()" placeholder="Usuario" [filter]="true" showClear styleClass="w-full"
            appendTo="body"></p-multiSelect>
    </div>
    <div class="input-field" style="min-width:170px">
        <label for="userTypeCode">Tipo de usuario</label>
        <p-dropdown [options]="userTypes" optionLabel="name" optionValue="code"
            [(ngModel)]="filters.userTypeCode.value" (onChange)="search()" placeholder="Tipo de usuario"
            showClear styleClass="w-full" appendTo="body"></p-dropdown>
    </div>
    <div class="input-field p-input-icon-right" style="min-width:150px">
        <label for="caseNumber">Expediente</label>
        <input pInputText placeholder="Expediente" [(ngModel)]="filters.caseNumber.value" (keydown.enter)="search()"
            class="w-full" />
        <i *ngIf="filters.caseNumber.value" class="pi pi-times cursor-pointer"
            (click)="filters.caseNumber.value = null; search()"></i>
    </div>
    <div class="input-field" style="min-width:170px">
        <label for="moduleCode">Módulo</label>
        <p-dropdown [options]="modules" optionLabel="name" optionValue="code" [(ngModel)]="filters.moduleCode.value"
            (onChange)="onModuleChange()" placeholder="Módulo" showClear styleClass="w-full"
            appendTo="body"></p-dropdown>
    </div>
    <div class="input-field" style="min-width:170px">
        <label for="submoduleCode">Submódulo</label>
        <p-dropdown [options]="submodules" optionLabel="name" optionValue="code"
            [(ngModel)]="filters.submoduleCode.value" (onChange)="search()" placeholder="Submódulo" showClear
            styleClass="w-full" appendTo="body"></p-dropdown>
    </div>
    <div class="input-field" style="min-width:170px">
        <label for="actionCode">Acción</label>
        <p-dropdown [options]="actions" optionLabel="name" optionValue="code" [(ngModel)]="filters.actionCode.value"
            (onChange)="search()" placeholder="Acción" showClear styleClass="w-full"
            appendTo="body"></p-dropdown>
    </div>
    <div class="input-field" style="max-width:134px">
        <label for="dateFrom">Desde</label>
        <p-calendar [firstDayOfWeek]="1" [(ngModel)]="filters.dateFrom.value" [showIcon]="true" [showTime]="false"
            [hourFormat]="'24'" dateFormat="dd/mm/yy" d-form-field-error appendTo="body"></p-calendar>
    </div>
    <div class="input-field" style="max-width:134px">
        <label for="dateTo">Hasta</label>
        <p-calendar [firstDayOfWeek]="1" [(ngModel)]="filters.dateTo.value" [showIcon]="true" [showTime]="false"
            [hourFormat]="'24'" dateFormat="dd/mm/yy" d-form-field-error appendTo="body"></p-calendar>
    </div>
    <div class="input-field" style="min-width:190px">
        <label for="minutesFromLastAction">Minutos desde última acción</label>
        <p-dropdown [options]="minutesOptions" optionLabel="name" optionValue="value"
            [(ngModel)]="filters.minutesFromLastAction.value" (onChange)="search()" placeholder="Cualquiera"
            showClear styleClass="w-full" appendTo="body"></p-dropdown>
    </div>

    <div class="input-field flex">
        <button pButton ngClass="mt-3" label="Buscar" icon="pi pi-search" (click)="search()"></button>
        <button pButton ngClass="mt-3 ml-2" label="Limpiar" icon="pi pi-eraser" (click)="clearFilters()"
            severity="secondary"></button>
    </div>
</div>
-->

<!-- reparto y franja horaria del periodo seleccionado, para no tener que descargar un fichero -->
<div class="grid mt-3" *ngIf="metrics.length > 0">

    <div class="col-12 lg:col-5">
        <div class="surface-card border-round p-3 h-full">
            <div class="flex align-items-center justify-content-between gap-2 mb-2">
                <span class="font-semibold">Actividad por módulo</span>
                <!-- input-field es lo que iguala el tamaño con los desplegables de los filtros -->
                <div class="input-field flex-none" style="width:180px">
                    <p-dropdown [options]="groupByOptions" optionLabel="name" optionValue="value"
                        [(ngModel)]="groupBy" (onChange)="onGroupByChange()" appendTo="body"></p-dropdown>
                </div>
            </div>
            <div class="text-2xl font-bold">{{totalActions}}</div>
            <div class="text-xs text-color-secondary mb-2">acciones en el periodo</div>
            <p-chart type="doughnut" [data]="moduleChartData" [options]="moduleChartOptions"
                height="220px"></p-chart>
        </div>
    </div>

    <div class="col-12 lg:col-7">
        <div class="surface-card border-round p-3 h-full">
            <div class="flex align-items-center justify-content-between gap-2 mb-2">
                <span class="font-semibold">Acciones por hora del día</span>
                <div class="input-field flex-none" style="width:180px">
                    <p-dropdown [options]="hourlyModeOptions" optionLabel="name" optionValue="value"
                        [(ngModel)]="hourlyMode" (onChange)="onHourlyModeChange()" appendTo="body"></p-dropdown>
                </div>
            </div>
            <div class="text-xs text-color-secondary mb-2">
                Hora local<span *ngIf="hourly && hourly.days > 1"> · {{hourly.days}} días con actividad</span>
            </div>
            <p-chart type="bar" [data]="hourlyChartData" [options]="hourlyChartOptions" height="220px"></p-chart>
        </div>
    </div>

</div>
<div class="mt-3 text-color-secondary" *ngIf="!chartsLoading && metrics.length == 0">
    Sin actividad registrada en el periodo seleccionado.
</div>

<p-table styleClass="mt-4" #grid [value]="userHistories" [lazy]="true" (onLazyLoad)="loadData($event)"
    [loading]="loading" [paginator]="true" [rows]="25" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
    currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
    [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
    <ng-template pTemplate="header">
        <tr>
            <th pSortableColumn="date" width="150">Fecha <p-sortIcon field="date"></p-sortIcon></th>
            <th width="180">Usuario</th>
            <th width="130">Tipo de usuario</th>
            <th width="140">Módulo</th>
            <th width="150">Submódulo</th>
            <th width="160">Acción</th>
            <th width="120">Expediente</th>
            <th>Información</th>
            <th pSortableColumn="minutesFromLastAction" width="110">Min. desde última <p-sortIcon
                    field="minutesFromLastAction"></p-sortIcon></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-userHistory>
        <tr>
            <td>{{userHistory.date | date:'dd/MM/yyyy HH:mm:ss'}}</td>
            <td>{{userHistory.user?.name}}</td>
            <td>{{userTypeName(userHistory.userTypeCode)}}</td>
            <td>{{userHistory.eventType?.moduleName ?? userHistory.module}}</td>
            <td>{{userHistory.eventType?.submoduleName}}</td>
            <td>{{userHistory.eventType?.actionName ?? userHistory.action}}</td>
            <td>{{userHistory.case?.caseNumber}}</td>
            <td>
                <span [innerHTML]="userHistory.information"></span>
                <div class="text-xs text-color-secondary" *ngIf="userHistory.fieldName">
                    {{userHistory.fieldName}}: {{userHistory.previousValue}} → {{userHistory.newValue}}
                </div>
            </td>
            <td>{{userHistory.minutesFromLastAction}}</td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="9">No hay actividad que coincida con los filtros.</td>
        </tr>
    </ng-template>
</p-table>
